import { apiGet } from '@gat-ship/http-client'
import type { GetCurrencyRefResponse } from '@gat-ship/types'

export async function getCurrencyRefRequest() {
  return await apiGet<GetCurrencyRefResponse>('ref-data/monetary/currencies')
}
